var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.375C5 2.16789 4.83211 2 4.625 2C4.41789 2 4.25 2.16789 4.25 2.375V2.75H3.5C2.67157 2.75 2 3.42157 2 4.25V12.5C2 13.3284 2.67157 14 3.5 14H12.5C13.3284 14 14 13.3284 14 12.5V4.25C14 3.42157 13.3284 2.75 12.5 2.75H11.75V2.375C11.75 2.16789 11.5821 2 11.375 2C11.1679 2 11 2.16789 11 2.375V2.75H5V2.375ZM3.90909 4.25H12.0909C12.3168 4.25 12.5 4.41789 12.5 4.625V5.375C12.5 5.58211 12.3168 5.75 12.0909 5.75H3.90909C3.68316 5.75 3.5 5.58211 3.5 5.375V4.625C3.5 4.41789 3.68316 4.25 3.90909 4.25Z",
    fill: "#0070BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFilled);
export default __webpack_public_path__ + "static/media/CalendarFilled.37f34eac1174033bb81648889fb0dca6.svg";
export { ForwardRef as ReactComponent };